import { render, staticRenderFns } from "./Portfolio2.vue?vue&type=template&id=ba8cf142&scoped=true&"
import script from "./Portfolio2.vue?vue&type=script&lang=js&"
export * from "./Portfolio2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8cf142",
  null
  
)

export default component.exports